export default "__VITE_ASSET__B0IN$Mi6__"